module.exports = __webpack_public_path__ + "static/img/10.bb7847e9.jpg";